import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { AppName } from '../config'

class BrowserIsEnable extends React.PureComponent {
  render() {
    return (
      <div className="browser-is-enable">
        <div className="title">
          <FormattedMessage
            id="browser_is_enable"
            defaultMessage={"You are opening {appName} on another Tab or have not used {appName} for too long"}
            values={{ appName: AppName }}
          />
        </div>
        <div className="desc">
          <FormattedMessage id="browser_is_enable_desc" defaultMessage={"Click activate to use on this Tab"} />
        </div>
        <a href="/" className="btn">
          <button>
            <FormattedMessage id="browser_is_enable_btn" defaultMessage={"Activate"} />
          </button>
        </a>
      </div>
    )
  }
}


export default injectIntl(BrowserIsEnable)
